// @flow

import _ from "lodash";
import React, { Component } from "react";
import { compose } from "react-apollo";
import ReactGA from "react-ga";

import type { Results } from "../../data/results";
// import type { retrieveProjectQueryResult } from "../../data/project";
// import type { userQueryResult } from "../../data/accounts";
import type {
  //  sessionQueryResult,
  //  updateSessionMutationResult,
  SessionType
} from "../../data/session";
import type { Limit } from "../../utils/progress";
import { withRouter } from "react-router";
// import type { RouterHistory } from "react-router";
import Page from "../../components/Page/Page";
import TaskManager from "../../components/TaskManager/TaskManager";
import BreakScreen from "./BreakScreen";
import QuestionHeader from "../../components/QuestionHeader/QuestionHeader";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import { workProgress } from "../../utils/progress";
import { withNetworkUserInfo } from "../../data/accounts";
import { withRetrieveProject } from "../../data/project";
import {
  withCompleteSession,
  withCreateSession,
  withSession
} from "../../data/session";
import WithTracker from "../../components/WithTracker/WithTracker";

type Screen = "break" | "tasks";

// type baseProps = {
//   projectId: string,
//   history: RouterHistory,
//   setHeader: (content: React.Element<*>) => void
// };
//
// type Props = baseProps &
//   sessionQueryResult &
//   userQueryResult &
//   retrieveProjectQueryResult &
//   updateSessionMutationResult;

type Props = Object; // FIXME: implement completeSessionType (and others)

type State = {
  results: Array<Results>,
  screen: Screen
};

type PartialState = {
  results?: Array<Results>,
  screen?: Screen
};

class Questions extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      results: [],
      screen: "tasks"
    };
    this.createSession();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.session()) {
      this.createSession();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !_.isEqual(this.props, nextProps) || !_.isEqual(this.state, nextState)
    );
  }

  componentDidUpdate() {
    this.updateHeader();
  }

  createSession() {
    if (!this.props.userData.user) {
      console.log(
        "Not logged in yet to create session, waiting for user object"
      );
      return;
    }

    console.log("Creating session");
    this.props
      .createSession({
        variables: {
          userId: this.props.userData.user.id,
          projectId: this.props.projectId,
          limitValue: 5,
          limitKind: "questions",
          assignmentId: null,
          maxBonusCents: null,
          basePayCents: null
        }
      })
      .then(response => {
        this.props.sessionData.refetch();
        this.updateHeader();
      });
  }

  isLoggedIn(): boolean {
    return this.props.userData && this.props.userData.user;
  }

  session(): ?SessionType {
    if (!this.props.sessionData) {
      return null;
    }
    if (!this.props.sessionData.user) {
      return null;
    }
    return _.first(this.props.sessionData.user.sessions);
  }

  sessionOrThrow(): SessionType {
    const session = this.session();
    if (!session) {
      throw new Error(
        `No session data found in props ${JSON.stringify(this.props)}`
      );
    }
    return session;
  }

  title(): ?string {
    return this.state.screen === "feedback" ? "How'd you do so far?" : null;
  }

  limit(): Limit {
    const session = this.sessionOrThrow();
    return {
      kind: session.limitKind,
      value: session.limitValue
    };
  }

  updateHeader(): void {
    const session = this.session();
    if (!session) {
      return;
    }
    const limit = this.limit();
    this.props.setHeader(
      <QuestionHeader
        progress={workProgress(limit, this.state.results)}
        unsetHeader={this.props.unsetHeader}
      />
    );
  }

  nextScreen(results: Array<Results>): Screen {
    const numQuestionsAnswered = results.length;
    if (numQuestionsAnswered % 5 === 0) {
      return "break";
    } else {
      return "tasks";
    }
  }

  handleTaskAdvance = (results: Results) => {
    // If there's some action that needs to happen when new
    // results are submitted, it goes here.

    // FIXME: results naming is confusing, Results vs Array<Results>
    const nextResults = this.state.results.concat([results]);
    const nextState = {
      results: nextResults,
      screen: this.nextScreen(nextResults)
    };
    ReactGA.set({ results: nextResults.length });

    this.advance(nextState);
  };

  advance = (nextState: PartialState) => {
    // If there's some action that needs to happen when a particular
    // screen is shown, it goes here.
    this.setState(nextState);
  };

  renderScreen() {
    const screen = this.state.screen;
    const session = this.session();
    const hasObjectiveAnswers = this.props.projectData.Project
      .hasObjectiveAnswers;
    switch (screen) {
      case "tasks":
        return (
          <TaskManager
            userId={this.props.userData.user.id}
            sessionId={session && session.id}
            projectId={this.props.projectId}
            onTaskAdvance={this.handleTaskAdvance}
          />
        );
      case "break":
        return (
          <BreakScreen
            projectId={this.props.projectId}
            hasObjectiveAnswers={hasObjectiveAnswers}
            userId={this.props.userData.user.id}
            sessionId={session && session.id}
            accept={() => this.advance({ screen: "tasks" })}
            decline={() => {
              const session = this.sessionOrThrow();
              this.props.completeSession({
                variables: {
                  id: session.id,
                  completed: true
                }
              });
              this.props.setHeader(null);
              this.props.history.push("/results");
            }}
          />
        );
      default:
        throw new Error(`Questions: Unknown screen type: ${screen}`);
    }
  }

  renderLoginReminder() {
    return <p>Loading questions... One moment please.</p>;
  }

  render() {
    return (
      <Page className="Questions" title={this.title()}>
        {this.isLoggedIn() ? this.renderScreen() : this.renderLoginReminder()}
      </Page>
    );
  }
}

const extendComponent = compose(
  WithTracker,
  withRetrieveProject,
  withNetworkUserInfo,
  withCompleteSession,
  withSession,
  withCreateSession,
  withRouter,
  WithLoadingIndicator
);

export default extendComponent(Questions);



// WEBPACK FOOTER //
// ./src/pages/Questions/Questions.js